import React from "react";
import moment from "moment";
import Disclaimers from "./Disclaimers";
import LastDifferingRecommendation from "./LastDifferingRecommendation";


export const RecentDisclosure = (props) => (
    <div className="x-recent-disclosure" style={{
        backgroundColor: "rgba(80,227,194,0.4)",
        margin: "10px",
        padding: "10px"
    }}>
        <span className="x-recent-disclosure-produced-on">{moment(props.disseminatedOn).calendar()}</span>
        <div style={{ backgroundColor: "white", padding: 10 }}>
            <span style={{ fontsize: "1.2em", fontWeight: "bold"}}>{props.direction} {props.instrumentSymbol}</span>
            <br/>
            Disclosure URL:
            <br/>
            <a className="x-disclosure-link" href={props.disclosureUri} target="_blank">{props.disclosureUri}</a>

            <LastDifferingRecommendation lastDifferingRecommendation={props.lastDifferingRecommendation} />
            <Disclaimers disclaimers={props.disclaimers} />
        </div>
    </div>

);
RecentDisclosure.propTypes = {
    direction: React.PropTypes.string.isRequired,
    disclosureUri: React.PropTypes.string.isRequired,
    disclaimers: React.PropTypes.object,
    disseminatedOn: React.PropTypes.string.isRequired,
    instrumentSymbol: React.PropTypes.string.isRequired
};

export default RecentDisclosure;




/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/RecentDisclosure.js
 **/